const prefix = "POINT_TRANSFER_HISTORY_";

export const PointTransferHisotyResources = {
  en: {
    [`${prefix}REGISTERED`]: "Registered",
  },
  jp: {
    [`${prefix}REGISTERED`]: "送金準備完了前",
    [`${prefix}PREPARED`]: "認証待ち",
    [`${prefix}CANCELED`]: "キャンセル",
    [`${prefix}EXECUTING`]: "手続き中",
    [`${prefix}EXECUTED`]: "送金完了",
    [`${prefix}FAILED`]: "エラー",
    [`${prefix}BANK_ACCOUNT`]: "銀行振込",
    RECEIVE_METHOD: "受け取り方法",
    FEE_FREE: "送金手数料1回分無料です！",
    FEE_NOT_FREE: "送金手数料がかかります",
    FEE_BANK_ACCOUNT: "銀行振込には、初回以降交換金額に応じて送金手数料(1P=1円)がかかります。",
    FEE_BANK_ACCOUNT_LESS_30000: "3万円未満の場合【220P】",
    FEE_BANK_ACCOUNT_MORE_30000: "3万円以上の場合【330P】",
    FEE_BANK_ACCOUNT_NOTE_1: "上記ポイントを差し引いた金額が実際の口座振込金額です。",
    FEE_BANK_ACCOUNT_NOTE_2: "振込まで数日かかります",
    FEE_BANK_ACCOUNT_NOTE_3: "振込先口座の登録が必要です",
    FEE_BANK_ACCOUNT_NOTE_4:
      "半年に1回、送金手数料が無料になります。（毎年1月1日、7月1日に新たに送金手数料無料を付与いたします）",
    ABOUT_BANK_ACCOUNT: "銀行振込について",
    [`${prefix}NOTHING`]: "詳細情報なし",
    [`${prefix}ACCOUNT_NOT_APPLICABLE`]: "該当口座なし",
    [`${prefix}DIFFERENT_ACCOUNT_NAME`]: "口座名義人相違",
    [`${prefix}DIFFERENT_ACCOUNT_NUMBER`]: "口座番号相違",
    [`${prefix}DIFFERENT_ACCOUNT_TYPE`]: "科目相違",
    [`${prefix}ACCOUNT_CANCELED`]: "口座解約",
    [`${prefix}OUT_OF_SERVICE_TIME`]: "受付時間外エラー",
    [`${prefix}OTHERS`]: "その他",
    NOTICE: "注意事項",
    [`${prefix}NOTICE_0`]: "振込先口座はGMO-PGサイトでの登録になります。\n口座情報は正しく入力してください。",
    [`${prefix}NOTICE_1`]: "振込先口座の入力誤りにより振込エラーが発生した場合は、エラー手数料（220P）*がかかります。",
    [`${prefix}NOTICE_2`]: "※送金手数料無料の申請時は、エラー手数料が無料になります。",
    [`${prefix}NOTICE_3`]: "誤った振込先に振込完了した場合、組み戻し(振込依頼の撤回)はいたしません。",
    [`${prefix}NOTICE_4`]: "より詳細については「銀行振込について」をご確認ください。",
    BANK_ACCOUNT_INFO_MAINTENANCE: "メンテナンス中は、ポイント交換申請の口座情報は表示されません。",
    BANK_NAME: "銀行名",
    BRANCH_NAME: "支店名",
    ACCOUNT_NUMBER: "口座番号",
    ACCOUNT_NAME: "名義人",
    CAMPAIGN: "キャンペーン",
    CURRENT: "普通口座",
    CHECKING: "当座口座",
    SAVINGS: "貯蓄口座",
  },
};
